<template>
  <!-- Display "City, State", only "State", or nothing depending on [business|home]_location completeness. -->
  <h3 v-if="location.city"
      class="company-location display-center md:text-l md:ml-0 lg:block left pl-5">
      {{ location.city }}, {{ location.state_province }}
  </h3>
  <h3 v-else="location.state_province"
      class="company-location display-center md:text-l md:ml-0 lg:block left">
      {{ location.state_province }}
  </h3>
</template>
<script>
export default {
    props: {
        location: Object
    }
}
</script>
